import { forwardRef } from 'react';

/**
 * The compact "E." brand mark (spec §5.1) for the tablet icon rail, the
 * mobile top bar and avatar-sized slots — anywhere the full `Wordmark` would
 * not fit. Reuses the `.etch-wordmark` type contract (font, colour, the red
 * square dot) rather than inventing a second class, just with a single
 * glyph and a compact default size.
 *
 * Same accessible-name concern as `Wordmark`: the visible "E" is hidden from
 * the accessibility tree and the mark is always announced as the full brand
 * name via `aria-label="Etch"`, never as the letter "E".
 *
 * @param {object} props
 * @param {'sm'|'md'|'lg'} [props.size='sm']
 * @param {'default'|'inverse'} [props.tone='default']
 * @param {import('react').ElementType} [props.as='span'] - render as e.g. `RouterLink`.
 * @param {string} [props.className]
 */
export const EtchMark = forwardRef(function EtchMark(
  { size = 'sm', tone = 'default', as: Component = 'span', className = '', ...rest },
  ref
) {
  return (
    <Component
      ref={ref}
      className={`etch-wordmark ${className}`.trim()}
      data-size={size === 'md' ? undefined : size}
      data-tone={tone === 'default' ? undefined : tone}
      aria-label="Etch"
      {...rest}
    >
      <span aria-hidden="true">
        E
        <span className="etch-wordmark__dot" aria-hidden="true" />
      </span>
    </Component>
  );
});

export default EtchMark;
